
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import isBeforeOrToday from '~/assets/utils/time/isBeforeOrToday'

export default Vue.extend({
  name: 'orderSummary',
  props: {
    forcedRender: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false as boolean,
      isOpenDetails: false as boolean,
      Holidays: [] as any,
      rendered: true,
      currentYear: new Date().getFullYear() as number,
    }
  },
  computed: {
    ...mapGetters({
      boxes: 'ship/boxes',
      trips: 'ship/trips',
      rates: 'ship/rates',
      units: 'ship/units',
      fees: 'ship/fees',
      details: 'ship/details',
      buckForBikes: 'payment/buckForBikes',
      selectedRateSpeed: 'ship/selectedRateSpeed',
      selectedRateSpeedIndex: 'ship/selectedRateSpeedIndex',
      pickupOption: 'ship/pickupOption',
      premiumProtection: 'ship/premiumProtection',
      subTotal: 'payment/subTotal',
      discountTotal: 'payment/discountTotal',
      session: 'user/session',
      discount: 'payment/discount',
      discountAmount: 'payment/discountAmount',
      stepNumber: 'ship/stepNumber',
      promoDiscount: 'payment/promoDiscount',
      promoDiscountAmount: 'payment/promoDiscountAmount',
      customerBalance: 'payment/customerBalance',
      customerBalanceApplied: 'payment/customerBalanceApplied',
    }),
  },
  watch: {
    fees: {
      deep: true,
      immediate: true,
      handler() {
        ;(this as any).calculateSubTotal()
      },
    },
    forcedRender() {
      const open = this.isOpen
      this.isOpen = false
      this.isOpen = true
      this.isOpen = open
    },
    session: {
      deep: true,
      immediate: false,
      async handler(newVal) {
        const _this = this
        if (newVal?.sessionType) {
          // when session loads, call to fill the user presets
          await _this.getDiscount()
          await _this.getCustomerBalance()
          _this.calculateSubTotal()
        } else {
          _this.unsetDiscount()
          _this.unsetCustomerBalance()
          _this.calculateSubTotal()
        }
      },
    },
  },
  async mounted() {
    if ((this as any).session && (this as any).session.sessionType) {
      await (this as any).getDiscount()
      await (this as any).getCustomerBalance()
      ;(this as any).calculateSubTotal()
    }
    this.Holidays = await this.getScheduledDates();
  },
  methods: {
    ...mapMutations({
      unsetDiscount: 'payment/unsetDiscount',
      unsetCustomerBalance: 'payment/unsetCustomerBalance',
    }),
    // Vuex actions
    ...mapActions({
      getRates: 'ship/getRates',
      calculateSubTotal: 'payment/calculateSubTotal',
      getDiscount: 'payment/getDiscount', // move this to payment store and optimize so that they are not called if not needed
      getCustomerBalance: 'payment/getCustomerBalance', // move this to payment store and optimize so that they are not called if not needed
      getScheduledDates: 'ship/getScheduledDates'
    }),
    onShow(): void {
      ;(this as any).isOpen = !(this as any).isOpen
    },
    onShowDetails(): void {
      ;(this as any).isOpenDetails = !(this as any).isOpenDetails
    },
    formatPrices(value: any): any {
      if (value === false) {
        return 'TBD'
      } else {
        return Number(parseFloat(value as string).toFixed(2)).toLocaleString(
          'en-US',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 }
        )
      }
    },
    getFormattedDiscount(): string {
      const discount = (this as any).discount
      if (discount && discount.discountType) {
        if (discount.discountType > 2) {
          return (
            '$' +
            (this as any).formatPrices(
              discount.discount *
                ((this as any).trips.length ? (this as any).trips.length : 1)
            )
          )
        } else if (discount.discountType > 1) {
          return '$' + (this as any).formatPrices(discount.discount)
        } else if ((this as any).discountAmount) {
          return '$' + (this as any).formatPrices((this as any).discountAmount)
        } else {
          return 'TBD'
        }
      }
      return 'TBD'
    },
    getFormattedPromoDiscount() {
      const promoDiscount = (this as any).promoDiscount
      if (promoDiscount && promoDiscount.discountType) {
        if (promoDiscount.discountType > 2) {
          return (
            '$' +
            (this as any).formatPrices(
              promoDiscount.discount *
                ((this as any).trips.length ? (this as any).trips.length : 1)
            )
          )
        } else if (promoDiscount.discountType > 1) {
          return '$' + (this as any).formatPrices(promoDiscount.discount)
        } else if ((this as any).promoDiscountAmount) {
          return (
            '$' + (this as any).formatPrices((this as any).promoDiscountAmount)
          )
        } else {
          return 'TBD'
        }
      }
      return 'TBD'
    },
    getFormattedCustomerBalance() {
      const amount = (this as any).customerBalanceApplied
      if (amount) {
        return '-$' + (this as any).formatPrices(amount)
      }
      return 'TBD'
    },
    formatDate(date: any, daysDelta = 0, raw = false): Date {      
      if (!date) {
        date = new Date()
      } else if (!date || typeof date === 'string' || date instanceof String) {
        date = new Date(date as string)
      }
      if (daysDelta) {
        let increment, skips, auxDate
        const userTimezoneOffset = date.getTimezoneOffset() * 60000
        const fixDate = date.toString().includes('+') ? date.getTime() + userTimezoneOffset : date.getTime() - userTimezoneOffset
        for (increment = 0, skips = 0, auxDate = new Date(fixDate); increment <= daysDelta && skips < 31; auxDate.setDate(auxDate.getDate() + 1)) {
          if (this.getDisabledDates(auxDate)) {
            skips++
          } else {
            increment++
          }
          if (increment > daysDelta)
            break
        }
        date = new Date(auxDate.getTime())
      }
      const userTimezoneOffset = date.getTimezoneOffset() * 60000
      const fixDate = date.toString().includes('+') ? date.getTime() - userTimezoneOffset : date.getTime() + userTimezoneOffset
      const dayOfWeek = new Date(fixDate).getDay()
      if (dayOfWeek === 6 || dayOfWeek === 0) {
        date.setDate(date.getDate() + (dayOfWeek === 6 ? 3 : 2))
      }
      if (raw) {
        return date
      }
      return date.toLocaleDateString(
        'en-us',
        {
          year: 'numeric',
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        }
      )
    },
    getDisabledDates(date : any): boolean{
      if(typeof date === 'string' || date instanceof String)
        date = new Date(date as string);
      if(date.getFullYear() > this.currentYear + 1)// disable if a date is a year in the future to improve performance
        return true;
      if(!(date.getDay() % 6))
        return true;
      if(isBeforeOrToday(date))
        return true;
      return this.isADayOff(date);
    },
    isADayOff(date: Date): boolean {
      if (this.Holidays && this.Holidays.length > 0) {
        for (let index = 0; index < this.Holidays.length; index++) {
          const holiday = new Date(this.Holidays[index])
          const parseHoliday = holiday.toISOString()
          const parseDate = date.toISOString()
          if (new Date(parseDate.split('T')[0]).getTime() === new Date(parseHoliday.split('T')[0]).getTime()) {
            return true
          }
        }
      }
      return false
    },
    // TODO: this function is repeated in many places, need to be in a service / package / store, whatever is best practice in VUE I did refactor of these functions in Costs.vue
    getToday(): any {
      return this.dateToISO(new Date())
    },
    // TODO: this function is repeated in many places, need to be in a service / package / store, whatever is best practice in VUE I did refactor of these functions in Costs.vue
    dateToISO(date: any): any {
      if (typeof date === 'string' || date instanceof String) {
        date = new Date(date as string)
      }
      if (date instanceof Date) {
        const offsetMs = date.getTimezoneOffset() * 60 * 1000
        const msLocal = date.getTime() - offsetMs
        const dateLocal = new Date(msLocal)
        const iso = dateLocal.toISOString()
        return iso.slice(0, 10)
      }
      return false
    },
    getCustomFees(index, rateIndex) {
      const fees =
        (this as any).fees &&
        (this as any).fees[index] &&
        (this as any).fees[index].landedCost
      const fee =
        fees && fees.length
          ? fees.filter((f) => f.stage === index && f.result === rateIndex)
          : 0
      if (fee === 0) return 0
      if (fee.length && fee[0].success) {
        return fee.length ? (fee[0].clearanceFee ? fee[0].clearanceFee : 0) : 0
      } else {
        return false
      }
    },
    getResidentialFees(index) {
      const fee = (this as any).fees?.[index]?.residentialFee ?? 0
      if (fee === 0) return 0
      return (this as any).fees[index].residentialFee
    },
    getFormattedAddress(index: number, direction: string): string {
      let address = ''
      const trip = (this as any).trips[index]?.[direction] ?? false
      if (!trip) {
        return address
      }
      const details =
        (this as any).details &&
        (this as any).details[index] &&
        (this as any).details[index][direction]
      if (!details) {
        return trip.formatted_address
      }

      address += (
        details.company && details.company.trim()
          ? details.company.trim() + ' '
          : ''
      ) as string
      address += (
        details.firstName && details.firstName.trim()
          ? details.firstName.trim() + ' '
          : ''
      ) as string
      address += (
        details.lastName && details.lastName.trim()
          ? details.lastName.trim() + ' '
          : ''
      ) as string
      if (trip.formatted_address && this.stepNumber < 3) {
        const parsedAddress = details.company
          ? trip.formatted_address?.replace(details.company, '')
          : trip.formatted_address
        address += parsedAddress + ' '
      } else {
        if (details.streetAddress && details.streetAddress.trim()) {
          address += (details.streetAddress.trim() + ', ') as string
        } else {
          address += (
            details.address1 && details.address1.trim()
              ? details.address1.trim() + ', '
              : ''
          ) as string
        }
        address += (
          details.address2 && details.address2.trim()
            ? details.address2.trim() + ', '
            : ''
        ) as string
        address += (
          details.address3 && details.address3.trim()
            ? details.address3.trim() + ' '
            : ''
        ) as string
        address += (
          details.city && details.city.trim() ? details.city.trim() + ', ' : ''
        ) as string
        address += (
          details.state && details.state.stateprovcode
            ? details.state.stateprovcode + ' '
            : ''
        ) as string
        address += (
          details.postalCode && details.postalCode.trim()
            ? details.postalCode.trim() + ' '
            : ''
        ) as string
      }
      address += (
        details.phone && details.phone.trim() ? details.phone.trim() : ''
      ) as string
      address += (
        details.country &&
        details.country.code &&
        !trip.formatted_address &&
        this.stepNumber > 2
          ? ', ' + details.country.code
          : ''
      ) as string
      address = address.replaceAll(' , ', ', ')
      address = address.replaceAll(', ,', ', ')

      if (!address && this.stepNumber < 3) {
        // if all failed, break the glass
        return trip.formatted_address
      }

      if (
        this.stepNumber < 3 &&
        details &&
        details.company &&
        address &&
        (address as string).trim().toLowerCase() ===
          (details.company as string).trim().toLowerCase()
      ) {
        // if address is only the company, bring back some company
        return trip.formatted_address
      }

      return address
    },
    getFormattedDates(index: number, type: string): string {
      try {
        let dates = ''
        const _this = this as any
        const selectedRateSpeedIndex = _this.selectedRateSpeedIndex?.[index]

        if (
          !(
            selectedRateSpeedIndex !== undefined &&
            _this.rates?.[0]?.[index]?.rates?.[selectedRateSpeedIndex]
          )
        ) {
          return dates
        }

        if( isBeforeOrToday( _this.rates[0][index].rates[selectedRateSpeedIndex].ship ) ) {
          return dates;
        }

        if( type === 'ship' ){
          dates = _this.convertEventDates(
            _this.rates[0][index].rates[selectedRateSpeedIndex].ship, true );
        }else if (!isBeforeOrToday(_this.rates[0][index].rates[selectedRateSpeedIndex].upsDeliver) && !isBeforeOrToday(_this.rates[0][index].rates[selectedRateSpeedIndex].deliver)) {
            if (_this.rates[0][index].rates[selectedRateSpeedIndex].upsDeliver !== _this.rates[0][index].rates[selectedRateSpeedIndex].deliver) {
              dates = _this.convertEventDates(_this.rates[0][index].rates[selectedRateSpeedIndex].upsDeliver, true) + ' - ' + _this.convertEventDates(_this.rates[0][index].rates[selectedRateSpeedIndex].deliver, true);
            } else {
              dates = _this.convertEventDates(_this.rates[0][index].rates[selectedRateSpeedIndex].upsDeliver, true);
            }
          }

        return dates
      } catch (e) {
        return ''
      }
    },
    reRender() {
      ;(this as any).rendered = false
      ;(this as any).rendered = true
    },
    getBoxLabel(box, bindex: number): string {
      try {
        let label = 'Box ' + (bindex + 1) + ': '
        if (box.preset) {
          label += box.preset
          label += ' // ' + box.length + ' x ' + box.width + ' x ' + box.height
          label += (this.units ? this.units.length : 'in') + ' '
          label += box.weight
          label += this.units ? this.units.weight : 'lb'
          return label
        }
        return ''
      } catch (e) {
        return ''
      }
    },
    convertEventDates(date: string, needDay?:boolean): string {
      const body = {
        month: 'short' as 'short',
        day: 'numeric' as 'numeric',
        year: 'numeric' as 'numeric',
        timeZone: 'UTC'
      }
      if (needDay) {
        const bodyExtend = { ...body, weekday: 'short' as 'short' }
        return new Date(date).toLocaleDateString('en-US', bodyExtend);
      }
      return new Date(date).toLocaleDateString('en-US', body);
    },
  }
});
